// Trạng thái phê duyệt
export enum EnumStatus {
    Pending = 0,
    Active = 1,
    Cancel = 2,
    Reject = 3
}

// Loại giao dịch
export enum DealType {
    Thuong = 1,
    HoanLai = 2,
    NapDiem = 3,
    RutDiem = 4,
    HoanDiemRut = 5,
    CongDiemDonHangDN = 6,
    TruDiemLenDonTrucTiep = 7,
    DongBang = 8,
}

// Trạng thái giao dịch 
export enum StatementStatus {
    ChuaXuLy = 0,
    ThanhCong = 1,
    DangXuLy = 2,
    Huy = 3,
    Loi = 4,
}

//Trạng thái đăng ký
export enum ProductRegStatus {
    ChoDuyet = 0,
    DaDuyet = 1,
    Huy = 2,
    TuChoi = 3,
}
// Trạng thái giao dịch 
export enum PointStatus {
    ChuaXuLy = 0,
    DangXuLy = 1,
    Huy = 2,
    KTDuyetThanhCong = 3,
    KTDuyetThatBai = 4,
    AdminDuyetThanhCong = 5,
    AdminDuyetThatBai = 6,
    Loi = 7,
    ThanhCong = 8
}

// // Chốt đơn hoặc hủy đơn
// export enum ActionsOrderType {
//     ConfirmedOrder = 1,     // Chốt đơn
//     CancelOrder = 2,  // Hủy đơn
//     CreateLogisticsOrder = 20,   // Đăng đơn
//     CancelLogisticsOrder = 4,   // Hủy đăng đơn
//     ChangeContactCode = 5,  // Đổi mã vận đơn
//     SyncLogisticStatus = 6,  // Cập nhật trạng thái giao hàng mới
//     CancelContactForBusinesses = 7  // Hủy chốt đơn
// }

export enum EnumOrderStatus {
    DaXacNhan = 1,
    DangChuanBiHang = 2,
    HoanGiaoHang = 3,
    DaChuanBiHangXong = 20,
    DaLayHang = 21,
    KhongLayDuocHang = 22,
    DangGiaoHang = 30,
    DaGiaoHang = 31,
    KhongGiaoDuoc = 33,
    YeuCauGiaoLai = 34,
    DangHoan = 40,
    DaHoan = 41,
    HuyDon = 999,
    ChuaXacNhan = 1000,
    TraLai = 4
}

export enum PromotionType {
    TongTien = 1,
    SanPham = 2,
    Code = 3,
    GiamTrucTiepTrenDonHang = 4,
}

export enum UserType {
    TrinhDuocVien = 1,
    DoanhNghiep = 2,
    Kho = 3,
    NhaThuoc = 4,
}

export enum PositionType {
    ChuSoHuu = 1,
    GiamSat = 2,
    NhanVien = 3,
    KeToan = 4,
    DVKH = 5,
    CSTDV = 6,
    CSKH = 7,
    NCC = 8,
    Other = 9,
}

export enum OptionBrowseImage {
    NotBrowse = -1, // null
    BrowseDisplay = 1, // trưng bày
    BrowseCheckinCollaborate = 2, // công tác
    BrowseCheckIn = 3, // viếng thăm
    // other option ...
}

export enum FileType {
    Image = 1,
    Audio = 2,
    Video = 3,
    Document = 4,
}

// Danh mục của từng loại
export enum CustomerTypeOption {
    IdCustomerType = 1, // Loại khách hàng
    IdGroupNT = 2,    // Nhóm NT
    // IdGroupTDV = 3,    // Nhóm TDV => Đổi sang dùng idOrganization
    idPharmacyType = 4,  // Loại hình nhà thuốc
}

export enum RoleCode {
    CSKH = 'CSKH',
    CTV = 'CTV',
    SHOP = 'SHOP',
    CUS = 'CUS',
    DN = 'DN',
    DNKT = 'DNKT',
    DNKHO = 'DNKHO',
    DNSALE = 'DNSALE',
    SUPPORT = 'SUPPORT',
    KT = 'KT',
    NCC = 'NCC',
    Admin = 'Admin',
    TDV = 'TDV'
}

export enum ServerToSyncConst {
    Odoo = 'Odoo',
    Grab = 'Grab',
    Be = "Be"
}

export enum VacationShiftType {
    NuaCaSang = 1,
    NuaCaChieu = 3,
    NhieuNgay = 4,
    CaNgay = 2
}
// export enum RequestCatalogType {
//     DonXinNghi = 1,
//     DonVangMat = 2,
//     DonThoiViec = 3,
//     DonLamThem = 4,
//     DonInOut = 5,
//     DonDoiCa = 6,
//     DonTangCa = 7,
//     DonDangKyCa = 8,
//     DonCongTac = 9,
//     DonCheDo = 10,
//     DonLamBu = 11,
//     NghiLeDacBiet = 999,
//     NghiBudacBiet = 1000
// }

export enum RequestCatalogType {
    DonXinNghi = 14,
    DonVangMat = 15,
    DonThoiViec = 16,
    DonLamThem = 17,
    DonInOut = 18,
    DonDoiCa = 19,
    DonTangCa = 20,
    DonDangKyCa = 21,
    DonCongTac = 22,
    DonCheDo = 23,
    DonLamBu = 24,
    NghiLeDacBiet = 999,
    NghiBudacBiet = 1000
}

export enum ConditionType {
    CaNhan = 1, // thiết lập ngưỡng cho cá nhân
    NhaCungCap = 2, // thiết lập ngưỡng số lượng cho nhà cung cấp đặt chỉ tiêu doanh số theo cá nhân
    //DonVi = 3 // Đơn vị tiền
}

export enum StatusApproveHrRequest {
    ChoDuyet = 0,
    HuyDuyet = 1,
    DaDuyet = 2,
    KhongDuyet = 3
};

// export class UsersType {
//     public static TrinhDuocVien = 1;
//     public static DoanhNghiep = 2;
//     public static Kho = 3;
//     public static NhaThuoc = 4;
// }

// export const UsersType = {
//     TrinhDuocVien: 1,
//     DoanhNghiep: 2,
//     Kho: 3,
//     NhaThuoc: 4,
// };

